export const actionOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "all": [
    {
      title: "Activate Rule",
      cls: "bulk-activate-rule",
      icon: "toggle-off",
      disabled:true
    },
    {
      title: "Deactivate Rule",
      cls: "bulk-deactivate-rule",
      icon: "toggle-on",
      disabled:true
    }
  ],
  "actions": [
    {
      title: "Edit Rule",
      cls: "edit-rule",
      icon: "pencil",
      disabled:false
    },
    {
      title: "Activate Rule",
      cls: "activate-rule",
      icon: "toggle-off",
      disabled:false
    },
    {
      title: "Deactivate Rule",
      cls: "inactivate-rule",
      icon: "toggle-on",
      disabled:false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/collateralRules/filter/actionOptions.js